import * as React from 'react';

export default ({ notification, onNotificationClicked, selected }) => {
    let classes = 'notification-item';
    if (selected) {
        classes += ' selected';
    }

    const status = notification.status();
    let date = WiseMetering.utils.formatDate(notification.get('created_at'));

    return (
        <div className={classes} onClick={() => onNotificationClicked(notification.id)}>
            <div className="notification-item-dot" data-status={status}>&nbsp;</div>
            <div className="notification-item__subject truncate">{notification.get('title')}</div>
            <div className="notification-item__details">
                <span className="notification-item__time truncate">{date}</span>
            </div>
        </div>
    );
};
